<script setup>
import { computed } from 'vue';
import { useDateFormat } from '@vueuse/core';
const props = defineProps({
  image: {
    type: Object,
    default: () => {},
  },
  tags: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: () => '',
  },
  date: {
    type: String,
    default: () => '',
  },
  url: {
    type: String,
    default: () => '',
  },
  theme: {
    type: String,
    default: () => '',
  },
});
const formattedDates = computed(() => {
  return useDateFormat(props.date, 'DD.MM.YYYY');
});
</script>
<template>
  <div :class="[`news__item news__item--${theme}`]">
    <CTagDetect
      v-if="url"
      :to="url"
      :class="['news__item-wrap', theme === 'black' ? 'white' : 'black']"
    >
      <div v-if="image" class="news__item-media">
        <NuxtImg
          v-if="image?.src"
          :src="image.src"
          :alt="image.alt"
          :height="image.height"
          :width="image.width"
          class="news__item-image"
          loading="lazy"
        />
      </div>
      <div class="news__item-info">
        <div class="news__item-top">
          <div v-if="tags && tags.length > 0" class="news__item-tags">
            <Tag
              v-for="tag in tags"
              :key="tag.value"
              :value="`#${tag.label}`"
              :class="[
                'news__item-tags-item body-3-regular',
                theme === 'black' ? 'white' : 'black',
              ]"
            />
          </div>
          <p v-if="title" class="mb-0 news__item-title h5" v-html="title"></p>
        </div>
        <div v-if="date" class="news__item-date body-3-regular">
          {{ formattedDates }}
        </div>
      </div>
    </CTagDetect>
    <div
      v-else
      :class="['news__item-wrap', theme === 'black' ? 'white' : 'black']"
    >
      <div v-if="image" class="news__item-media">
        <NuxtImg
          v-if="image?.src"
          :src="image.src"
          :alt="image.alt"
          :height="image.height"
          :width="image.width"
          class="news__item-image"
          loading="lazy"
        />
      </div>
      <div class="news__item-info">
        <div class="news__item-top">
          <div v-if="tags && tags.length > 0" class="news__item-tags">
            <Tag
              v-for="tag in tags"
              :key="tag.value"
              :value="`#${tag.label}`"
              :class="[
                'news__item-tags-item body-3-regular',
                theme === 'black' ? 'white' : 'black',
              ]"
            />
          </div>
          <p v-if="title" class="mb-0 news__item-title h5" v-html="title"></p>
        </div>
        <div v-if="date" class="news__item-date body-3-regular">
          {{ formattedDates }}
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@use 'sass:math';
.news__item {
  border-radius: 8px;
  height: 100%;
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(border-radius, 8);
  }
  &--white {
    background-color: $gray;
  }
  &--black {
    background-color: rgba($surface-container-opacity, 0.5);
  }
  &--gray {
    background-color: $white;
  }
  &-wrap {
    display: grid;
    gap: 24px;
    grid-template-columns: 1fr;
    grid-template-rows: min-content auto;
    height: 100%;
    padding: 16px;
    @include media-breakpoint-up(sm) {
      gap: 32px;
      padding: 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 32);
      @include responsive-spacing(padding, 24);
    }
  }
  &-media {
    border-radius: 4px;
    aspect-ratio: 1/1;
    overflow: hidden;
    width: 67.6%;
    @include media-breakpoint-up(sm) {
      width: 51.3%;
    }
    @include media-breakpoint-up(md) {
      width: 46.9%;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
    }
  }
  &-image {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  &-info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    @include media-breakpoint-up(sm) {
      gap: 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 24);
    }
  }
  &-top {
    display: flex;
    flex-direction: column;
    gap: 8px;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
    }
  }
  &-tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
    }
    &-item {
      background-color: transparent;
      padding: 0;
    }
  }
  &-title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  &-date {
    margin-top: auto;
  }
}
</style>
